export default "__VITE_ASSET__38b2670d__"